export default "__VITE_ASSET__BMNwsxga__"